module.exports = __webpack_public_path__ + "img/arrow_down.986e044d.svg";